module.exports = {
  email: 'mail.hardik.gosai@gmail.com',

  socialMedia: [
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/hardik-gosai/',
      icon: 'fa-brands fa-linkedin'
    },
    {
      name: 'GitLab',
      url: 'https://gitlab.com/hardik.gosai',
      icon: 'fa-brands fa-gitlab'
    },
    {
      name: 'Steam',
      url: 'https://steamcommunity.com/id/rorschach_47/',
      icon: 'fa-brands fa-square-steam'
    },
    {
      name: 'Discord',
      url: 'https://discordapp.com/users/1194983567827148914',
      icon: 'fa-brands fa-discord'
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
